import React from "react";
import { Row, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import UploadButton from "./UploadBtn";
import metaData from "../../data/metaData";

const LogoPlaceholder = () => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{
        width: "10rem",
        height: "10rem",
        background: "var(--ion-color-step-50)",
      }}
    >
      <UploadOutlined style={{ fontSize: "1.25rem" }} />
      <div
        style={{
          marginTop: 8,
        }}
      ></div>
    </Row>
  );
};

const LogoUploader = ({ logo, onFinish, readOnly, aspect = 1 }) => {
  const { t, i18n } = useTranslation();
  return (
    <div style={{ display: "flex", marginBottom: "24px" }}>
      {logo ? (
        <img
          style={{
            objectFit: "cover",
            width: "10rem",
            height: "10rem",
            backgroundColor: "var(--ion-color-step100)",
          }}
          src={metaData.blobPreURL + "clientUpload-" + logo + ".jpeg" + metaData.blobPostURL}
        />
      ) : (
        <LogoPlaceholder />
      )}

      {readOnly ? null : (
        <div style={{ marginLeft: "1rem" }}>
          <p>Upload a logo photo, recommend 1:1 aspect radio</p>
          <p>JPG or PNG. Max size of 5MB</p>
          <UploadButton
            onFinish={(url) => {
              onFinish({ logo: url });
            }}
            buttonLabel={logo ? t("newVendor.ChooseAnother") : "Choose photo"} // Dynamic label
            aspect={aspect}
          />
        </div>
      )}
    </div>
  );
};

export default LogoUploader;
